/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsItalic: {
  name: 'italic';
  data: string;
} = {
  name: 'italic',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 3h-4a1 1 0 1 0 0 2h.795L10.17 19H9a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-.795L14.83 5H16a1 1 0 1 0 0-2Z" fill="currentColor"/></svg>`,
};
